import { useState } from "react";
/**
 * useState que persiste no sessionStorage. O valor do sessionStorage é excluído quando o usuário fecha o navegador.
 * @template T
 * @param {string} key chave do item a ser salvo
 * @param {T} initialValue valor inicial
 * @returns {[T, (value: T|((prevState: T) => T)) => void, () => void]} valor, função para atualizar o valor, função para resetar o valor
 */
export function useSessionStorage(key, initialValue) {
	const [storedValue, setStoredValue] = useState(() => {
		try {
			const item = window.sessionStorage.getItem(key);
			if (!item)
				window.sessionStorage.setItem(
					key,
					JSON.stringify(initialValue)
				);
			return item ? JSON.parse(item) : initialValue;
		} catch (error) {
			console.log(error);
			return initialValue;
		}
	});

	const setValue = (value) => {
		try {
			setStoredValue((prev) => {
				const valueToStore =
					value instanceof Function ? value(prev) : value;
				window.sessionStorage.setItem(
					key,
					JSON.stringify(valueToStore)
				);
				return valueToStore;
			});
		} catch (error) {
			console.log(error);
		}
	};
	const reset = () => {
		window.sessionStorage.removeItem(key);
	};
	return [storedValue, setValue, reset];
}
